export type SeoMetricStatus = 'Excellent' | 'Good' | 'Poor';
export type SeoTaskPriority = 'High Priority' | 'Medium' | 'Low Priority';

export const seoMetricStatusClassName: Record<SeoMetricStatus, string> = {
    Excellent: 'bg-indigo-100 text-indigo-700',
    Good: 'bg-emerald-50 text-emerald-700',
    Poor: 'bg-rose-50 text-rose-700',
};

export const seoTaskPriorityClassName: Record<SeoTaskPriority, string> = {
    'High Priority': 'bg-rose-50 text-rose-700',
    Medium: 'bg-amber-50 text-amber-700',
    'Low Priority': 'bg-emerald-50 text-emerald-700',
};
